import { CustomTheme } from "./interface";

export const fontSizes: CustomTheme["other"]["fontSizes"] = {
  large: "20px",
  medium: "18px",
  regular: "16px",
  small: "14px",
  tiny: "12px",
};
